import {connect} from "react-redux";
import AttendanceRecordDetails from "./AttendanceRecordDetails";
import {bindActionCreators} from "redux";
import { getDaysData, meetingDataForADate } from "../../service/DarwinAttendance/action";

const mapStateToProps = (state) => ({
    getAllTheDaysData: state.DarwinAttendanceSync.getAllTheDaysData,
    getAttendanceData: state.DarwinAttendanceSync.getAttendanceData
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getDaysData,
            meetingDataForADate
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(AttendanceRecordDetails);
